// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function Table({ value }) {
  function displayTableHeader() {
    const tabe = [];
    for (let i = 0; i < 1; i += 1) {
      tabe.push(
        <thead key={i}>
          <tr>
            {value.data[i].map((el) => {
              const tabeBis = [];
              tabeBis.push(
                <th key={el} scope="col">{el}</th>,
              );
              return tabeBis;
            })}
          </tr>
        </thead>,
      );
    }
    return tabe;
  }
  function displayTableBody() {
    const tabe = [];
    for (let i = 1; i < value.data.length; i += 1) {
      tabe.push(
        <tbody key={i}>
          <tr>
            {value.data[i].map((el) => {
              const tabeBis = [];
              tabeBis.push(
                <td key={el}>{el}</td>,
              );
              return tabeBis;
            })}
          </tr>
        </tbody>,
      );
    }
    return tabe;
  }
  return (
    <div className="table--container">
      <table>
        {displayTableHeader()}
        {displayTableBody()}
      </table>
    </div>
  );
}

Table.propTypes = {
  value: PropTypes.shape({
    cell: PropTypes.array.isRequired,
    data: PropTypes.array.isRequired,
  }).isRequired,
};

export default Table;
